import React, { useState } from "react";

const FileUploadComponent = ({ setFieldValue, setFieldTouched }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewContent, setPreviewContent] = useState(null); // Handle image or PDF preview
  const [fileType, setFileType] = useState(null); // Track file type

  const handleFileChange = (event) => {
    setFieldTouched("file");
    handleFile(event.target.files[0]);
  };

  const handleDragOver = (event) => {
    setFieldTouched("file");
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    handleFile(file);
  };

  const handleFile = (file) => {
    if (file) {
      const fileType = file.type;
      setFileType(fileType);

      // Preview logic
      if (fileType.startsWith("image/")) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewContent(
            <img src={reader.result} alt="Preview" className="preview-image" />
          );
        };
        reader.readAsDataURL(file);
      } else if (fileType === "application/pdf") {
        const fileURL = URL.createObjectURL(file);
        setPreviewContent(
          <div className="pdf-preview">
            <p>{file.name}</p>
            <a
              href={fileURL}
              target="_blank"
              rel="noopener noreferrer"
              className="view-pdf-link"
            >
              View PDF
            </a>
          </div>
        );
      } else {
        setPreviewContent(null);
        // alert("Unsupported file type. Please upload an image or PDF.");
      }

      // Set the selected file
      setSelectedFile(file);
      setFieldValue("file", file);
    }
  };

  return (
    <div
      className="file-upload-container"
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      <label className="file-upload-label">
        <input
          name="file"
          type="file"
          accept="image/*,application/pdf"
          onChange={handleFileChange}
          style={{ display: "none" }}
        />
        Upload License Document
      </label>
      <p>
        Please select a file in one of the following formats: Images (JPEG, PNG)
        or PDF. Maximum file size: 5MB.
      </p>
      <p>or</p>
      <p>Drag and drop your license document here</p>

      {previewContent ? (
        <div className="file-preview">{previewContent}</div>
      ) : (
        <p>No file selected</p>
      )}
    </div>
  );
};

export default FileUploadComponent;
